module.exports = __webpack_public_path__ + "static/media/saturn.a04761e7.svg";